import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptionBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"receiption-bell, concierge, assistant"} maskId="square-filled-radius-0-stroke-1-IconReceiptionBell"><path d="M12.502 6.01419V4H15.002V3H9.00195V4H11.502V6.01419C6.7173 6.28701 3.00195 10.4668 3.00195 16.3281V18H11.502V20H3V21H21V20H12.502V18H21.002V16.3281C21.002 10.4668 17.2866 6.28701 12.502 6.01419Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconReceiptionBell;
